import { render, staticRenderFns } from "./SettingsJustifyContent.vue?vue&type=template&id=07a3d1a0&"
import script from "./SettingsJustifyContent.vue?vue&type=script&lang=js&"
export * from "./SettingsJustifyContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports